import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AdminLayoutModule } from '../../admin-layout/admin-layout.module';
import { CoreModule } from '../../core/core.module';
import { ShivePopupDirective } from '../../core/directives/shive-popup.directive';
import { FeaturesModule } from '../../features/features.module';
import { SharedModule } from '../../shared/shared.module';
import { AbsencePlannerComponent } from './absences/absence-planner/absence-planner.component';
import { AbsencesComponent } from './absences/absences.component';
import { LeaveRequestsComponent } from './absences/leave-requests/leave-requests.component';
import { VacationQuotaComponent } from './absences/vacation-insights/vacation-quota.component';
import { InvitationDialogComponent } from './dialogs/invitation-dialog/invitation-dialog.component';
import { TeamListComponent } from './team-list/team-list.component';
import { TeamComponent } from './team.component';

@NgModule({
  declarations: [
    TeamComponent,
    TeamListComponent,
    AbsencesComponent,
    AbsencePlannerComponent,
    VacationQuotaComponent,
    LeaveRequestsComponent,
    InvitationDialogComponent,
  ],
  imports: [
    CommonModule,
    RouterOutlet,
    CoreModule,
    SharedModule,
    ShivePopupDirective,
    FeaturesModule,
    AdminLayoutModule,
  ],
})
export class TeamModule {}
